module.exports = __webpack_public_path__ + "static/media/4_Dicut_01.ba83741a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/Printing-Techniques/4_Dicut_01.jpg
// module id = 1736
// module chunks = 0